@defer {
  <signals-feed-list
    *ngIf="isLoadingFeeds || feeds?.length"
    [feeds]="feeds"
    [listenToScroll]="listenToScroll"
    [isLoading]="isLoadingFeeds"
    [preFeedButton]="preFeedButton"
    [feedPartClicked]="feedPartClicked"
    [feedPartClickTooltip]="feedPartClickTooltip"
    [actions]="actions"
    [filter]="filter"
    [tenantUri]="tenantUri"
    [userEvaluations]="userEvaluations"
    [evaluationBasis]="evaluationBasis"
    (onActionTriggered)="onActionTriggered.emit($event)"
    (trackEvent)="trackEvent.emit($event)"
    (trackSurveyActionEvent)="onTrackSurveyActioned($event)"
    (scrollToEnd)="scrollToEnd()"
    (hideSignal)="hideSignal($event)"
  ></signals-feed-list>
}

<div *ngIf="!isLoadingFeeds && !feeds?.length">
  <signals-empty-list [searchTips]="filterSpecificSearchTips || searchTips"></signals-empty-list>
</div>
